/* eslint-disable no-unused-vars */
export var PlayerCleave;
(function (PlayerCleave) {
    PlayerCleave["LEFT"] = "LEFT";
    PlayerCleave["RIGHT"] = "RIGHT";
    PlayerCleave["NOTHING"] = "NOTHING";
})(PlayerCleave || (PlayerCleave = {}));
